export const sortTargetMarket = (targetMarketList) => {
  if (!targetMarketList) return [];
  const USMarket = targetMarketList.find((marketItem) => {
    return marketItem.Numeric === 840;
  });

  const noneUSMarketList = targetMarketList.filter((marketItem) => {
    return marketItem.Numeric !== 840;
  });

  const sortedNoneUSMarketList = noneUSMarketList.sort((a, b) => {
    return a.Country.localeCompare(b.Country);
  });

  return USMarket
    ? [USMarket, ...sortedNoneUSMarketList]
    : sortedNoneUSMarketList;
};
